module.exports = __webpack_public_path__ + "static/mbdb.io-5b796eb190d1ff64e4144a90192cb970.png";